var React = require('react');

function ArrowRightLarge (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeWidth":"6"},[React.createElement("path",{"d":"M25.01 45.21L46.23 24 25.01 2.79","key":0}),React.createElement("path",{"d":"M3.51 23.75H41","strokeLinecap":"square","key":1})]));
}

ArrowRightLarge.defaultProps = {"viewBox":"0 0 51 48"};

module.exports = ArrowRightLarge;

ArrowRightLarge.default = ArrowRightLarge;
